export const translations = {
  en: {
    nav: {
      services: "Services",
      catalog: "Catalog",
      hotels: "Hotels",
      fleet: "Fleet",
      destinations: "Destinations",
      about: "About",
      contact: "Contact",
      bookNow: "Book Now",
    },
    hero: {
      eyebrow: "PREMIUM TRANSPORTATION · CANCUN & RIVIERA MAYA",
      title: "Your private gateway to the Caribbean.",
      subtitle:
        "Door-to-door airport transfers and exclusive tours across Quintana Roo. Met by a uniformed driver, delivered in style.",
      cta: "Reserve your transfer",
      ctaSecondary: "Explore services",
    },
    services: {
      eyebrow: "WHAT WE OFFER",
      title: "Travel without compromise.",
      items: [
        {
          name: "One-way Airport Transfer",
          desc: "Cancun International Airport to any hotel in the zone. Meet & greet, flight tracking, zero waiting fees.",
          from: "From $75 USD",
          id: "one-way",
        },
        {
          name: "Round Trip Transfer",
          desc: "Arrival and departure handled by the same trusted team. Save when you book the return.",
          from: "From $140 USD",
          id: "round-trip",
        },
        {
          name: "Private Tours & Excursions",
          desc: "Chichén Itzá, Tulum, Xcaret, Cobá, Isla Mujeres. Custom routes with English-speaking guides.",
          from: "From $220 USD",
          id: "tour",
        },
      ],
    },
    fleet: {
      eyebrow: "THE FLEET",
      title: "Discreet, comfortable, immaculate.",
      desc: "From mid-size SUVs to spacious Sprinter vans and luxury sedans — every vehicle is privately licensed, fully insured, and detailed before every ride.",
      vehicles: [
        { name: "Executive SUV", capacity: "Up to 5 passengers", luggage: "5 suitcases" },
        { name: "Sprinter Van", capacity: "Up to 14 passengers", luggage: "14 suitcases" },
        { name: "Luxury Sedan", capacity: "Up to 3 passengers", luggage: "3 suitcases" },
      ],
    },
    destinations: {
      eyebrow: "WHERE WE GO",
      title: "From the airport to anywhere worth going.",
      desc: "Cancun Hotel Zone · Playa del Carmen · Tulum · Akumal · Puerto Morelos · Isla Mujeres · Chichén Itzá · Xcaret · Cobá · Bacalar",
    },
    booking: {
      eyebrow: "BOOK YOUR TRANSFER",
      title: "Reserve in under two minutes.",
      service: "Service",
      serviceTypes: {
        "one-way": "Airport → Hotel (One-way)",
        "round-trip": "Round Trip (Arrival + Departure)",
        "tour": "Private Tour / Excursion",
      },
      vehicle: "Vehicle",
      vehicles: {
        suv: "Executive SUV (up to 5)",
        van: "Sprinter Van (up to 14)",
        luxury: "Luxury Sedan (up to 3)",
      },
      pickup: "Pickup location",
      pickupPh: "Cancun International Airport (T1, T2, T3, T4)",
      dropoff: "Drop-off location",
      dropoffPh: "Hotel name or full address",
      date: "Pickup date",
      time: "Pickup time",
      returnDate: "Return date",
      returnTime: "Return time",
      passengers: "Passengers",
      luggage: "Suitcases",
      flight: "Flight number",
      flightPh: "AA1234",
      airline: "Airline",
      airlinePh: "American Airlines",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      requests: "Special requests",
      requestsPh: "Child seat, accessibility needs, stops, etc.",
      estimate: "Estimated total",
      submit: "Confirm reservation",
      submitting: "Sending...",
      successTitle: "Reservation received",
      successMsg: "Our team will confirm your booking by email within minutes.",
      payNote: "Payment via Stripe / PayPal will be available shortly. For now we confirm by email.",
      pickDate: "Pick a date",
    },
    trust: {
      eyebrow: "WHY HARD ROCK MEMBERS",
      items: [
        { title: "Licensed & insured", desc: "Federal permits, commercial insurance, certified drivers." },
        { title: "Meet & greet", desc: "Uniformed driver waiting at arrivals with your name on the sign." },
        { title: "Flight tracking", desc: "We monitor your flight in real time. Delays cost you nothing." },
        { title: "24/7 support", desc: "Bilingual concierge available anytime, before, during, and after your trip." },
      ],
    },
    testimonials: {
      eyebrow: "GUEST STORIES",
      title: "Trusted by travelers from across the world.",
      items: [
        {
          quote: "Driver was already waiting when we landed at 1 AM. Pristine SUV, ice-cold water, easy WhatsApp updates the whole way.",
          author: "Jessica R.",
          origin: "Atlanta, GA",
        },
        {
          quote: "Booked the Chichén Itzá tour. Knowledgeable guide, flexible schedule, and zero tourist trap nonsense. Best decision of the trip.",
          author: "Mark & Elena T.",
          origin: "Madrid, Spain",
        },
        {
          quote: "Round-trip from Tulum was flawless. Felt safer than any taxi or shuttle. We will only book with them from now on.",
          author: "The Patel family",
          origin: "Toronto, Canada",
        },
      ],
    },
    contact: {
      eyebrow: "GET IN TOUCH",
      title: "We answer in minutes, not days.",
      name: "Your name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sending: "Sending...",
      sent: "Message sent. We'll be in touch shortly.",
      callUs: "Call or WhatsApp",
      emailUs: "Email",
      offices: "Offices",
    },
    footer: {
      tagline: "Premium private transportation in Cancun & Riviera Maya since day one.",
      quickLinks: "Quick Links",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      copyright: "© 2026 Hard Rock Members. All rights reserved.",
    },
    privacy: {
      title: "Privacy Policy",
      updated: "Last updated: February 2026",
    },
    terms: {
      title: "Terms & Conditions",
      updated: "Last updated: February 2026",
    },
  },
  es: {
    nav: {
      services: "Servicios",
      catalog: "Catálogo",
      hotels: "Hoteles",
      fleet: "Flota",
      destinations: "Destinos",
      about: "Nosotros",
      contact: "Contacto",
      bookNow: "Reservar",
    },
    hero: {
      eyebrow: "TRANSPORTE PREMIUM · CANCÚN Y RIVIERA MAYA",
      title: "Tu acceso privado al Caribe.",
      subtitle:
        "Traslados puerta a puerta desde el aeropuerto y tours exclusivos por Quintana Roo. Recibido por un chofer uniformado y trasladado con estilo.",
      cta: "Reservar mi traslado",
      ctaSecondary: "Ver servicios",
    },
    services: {
      eyebrow: "LO QUE OFRECEMOS",
      title: "Viajar sin compromisos.",
      items: [
        {
          name: "Traslado de aeropuerto sencillo",
          desc: "Del aeropuerto de Cancún a cualquier hotel de la zona. Recepción con cartel, monitoreo de vuelo, sin cargos por espera.",
          from: "Desde $75 USD",
          id: "one-way",
        },
        {
          name: "Traslado redondo",
          desc: "Llegada y salida con el mismo equipo de confianza. Ahorra al reservar el regreso.",
          from: "Desde $140 USD",
          id: "round-trip",
        },
        {
          name: "Tours privados y excursiones",
          desc: "Chichén Itzá, Tulum, Xcaret, Cobá, Isla Mujeres. Rutas a medida con guías bilingües.",
          from: "Desde $220 USD",
          id: "tour",
        },
      ],
    },
    fleet: {
      eyebrow: "LA FLOTA",
      title: "Discreta, cómoda, impecable.",
      desc: "Desde SUVs medianas hasta amplias vans Sprinter y sedanes de lujo — cada vehículo cuenta con licencia privada, seguro completo y detallado antes de cada viaje.",
      vehicles: [
        { name: "SUV Ejecutiva", capacity: "Hasta 5 pasajeros", luggage: "5 maletas" },
        { name: "Sprinter Van", capacity: "Hasta 14 pasajeros", luggage: "14 maletas" },
        { name: "Sedán de lujo", capacity: "Hasta 3 pasajeros", luggage: "3 maletas" },
      ],
    },
    destinations: {
      eyebrow: "A DÓNDE VAMOS",
      title: "Del aeropuerto a cualquier lugar que valga la pena.",
      desc: "Zona Hotelera Cancún · Playa del Carmen · Tulum · Akumal · Puerto Morelos · Isla Mujeres · Chichén Itzá · Xcaret · Cobá · Bacalar",
    },
    booking: {
      eyebrow: "RESERVA TU TRASLADO",
      title: "Reserva en menos de dos minutos.",
      service: "Servicio",
      serviceTypes: {
        "one-way": "Aeropuerto → Hotel (Sencillo)",
        "round-trip": "Redondo (Llegada + Salida)",
        "tour": "Tour privado / Excursión",
      },
      vehicle: "Vehículo",
      vehicles: {
        suv: "SUV Ejecutiva (hasta 5)",
        van: "Sprinter Van (hasta 14)",
        luxury: "Sedán de Lujo (hasta 3)",
      },
      pickup: "Lugar de recogida",
      pickupPh: "Aeropuerto Internacional de Cancún (T1, T2, T3, T4)",
      dropoff: "Lugar de destino",
      dropoffPh: "Nombre del hotel o dirección completa",
      date: "Fecha de recogida",
      time: "Hora de recogida",
      returnDate: "Fecha de regreso",
      returnTime: "Hora de regreso",
      passengers: "Pasajeros",
      luggage: "Maletas",
      flight: "Número de vuelo",
      flightPh: "AA1234",
      airline: "Aerolínea",
      airlinePh: "American Airlines",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono / WhatsApp",
      requests: "Solicitudes especiales",
      requestsPh: "Silla para niño, accesibilidad, paradas, etc.",
      estimate: "Total estimado",
      submit: "Confirmar reservación",
      submitting: "Enviando...",
      successTitle: "Reservación recibida",
      successMsg: "Nuestro equipo confirmará tu reserva por correo en cuestión de minutos.",
      payNote: "El pago por Stripe / PayPal estará disponible próximamente. Por ahora confirmamos por correo.",
      pickDate: "Selecciona una fecha",
    },
    trust: {
      eyebrow: "POR QUÉ HARD ROCK MEMBERS",
      items: [
        { title: "Con licencia y seguro", desc: "Permisos federales, seguro comercial y choferes certificados." },
        { title: "Recepción personal", desc: "Chofer uniformado esperándote en llegadas con tu nombre en el cartel." },
        { title: "Monitoreo de vuelo", desc: "Seguimos tu vuelo en tiempo real. Las demoras no te cuestan nada." },
        { title: "Soporte 24/7", desc: "Conserjería bilingüe disponible siempre, antes, durante y después del viaje." },
      ],
    },
    testimonials: {
      eyebrow: "HISTORIAS DE HUÉSPEDES",
      title: "Viajeros de todo el mundo confían en nosotros.",
      items: [
        {
          quote: "El chofer ya estaba esperando cuando aterrizamos a la 1 AM. SUV impecable, agua helada y avisos por WhatsApp todo el camino.",
          author: "Jessica R.",
          origin: "Atlanta, GA",
        },
        {
          quote: "Reservé el tour a Chichén Itzá. Guía culto, horarios flexibles y sin trampas para turistas. La mejor decisión del viaje.",
          author: "Mark y Elena T.",
          origin: "Madrid, España",
        },
        {
          quote: "El redondo desde Tulum fue impecable. Me sentí más seguro que en cualquier taxi o shuttle. Solo reservaremos con ellos.",
          author: "Familia Patel",
          origin: "Toronto, Canadá",
        },
      ],
    },
    contact: {
      eyebrow: "CONTÁCTANOS",
      title: "Respondemos en minutos, no en días.",
      name: "Tu nombre",
      email: "Correo",
      phone: "Teléfono",
      subject: "Asunto",
      message: "Mensaje",
      send: "Enviar mensaje",
      sending: "Enviando...",
      sent: "Mensaje enviado. Te contactaremos pronto.",
      callUs: "Llama o WhatsApp",
      emailUs: "Correo",
      offices: "Oficinas",
    },
    footer: {
      tagline: "Transporte privado premium en Cancún y Riviera Maya desde el primer día.",
      quickLinks: "Enlaces rápidos",
      legal: "Legal",
      privacy: "Política de privacidad",
      terms: "Términos y condiciones",
      copyright: "© 2026 Hard Rock Members. Todos los derechos reservados.",
    },
    privacy: {
      title: "Política de privacidad",
      updated: "Última actualización: Febrero 2026",
    },
    terms: {
      title: "Términos y condiciones",
      updated: "Última actualización: Febrero 2026",
    },
  },
};
